import React from 'react'
import styled from 'styled-components'
import { ButtonsBox, TotalWrapper } from '../PDRCredits/Styles/Shared.styles'
import { Title } from '../Widget'
import { Button } from '../../Button'

const ErrorContainer = styled.div`
  width: 100%;
  padding: 24px;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  @media(max-width: 768px) {
    padding: 16px;
  }
  @media(max-width: 480px) {
    padding: 12px;
  }
`

const ErrorLoading = ({ refetch, reload }) => (
  <ErrorContainer>
    <Title text='Error' />
    <div>
      <TotalWrapper>Failed to load</TotalWrapper>
      <br />
    </div>
    <br />
    <ButtonsBox>
      <Button onClick={() => reload(refetch)}>REFRESH</Button>
    </ButtonsBox>
  </ErrorContainer>
)

export default ErrorLoading
